/* eslint-disable no-use-before-define */
/* eslint-env browser */
import 'wicg-inert';

const hideModal = (modal, sender, callback = () => {}) => {
  const modalView = document.getElementById(modal);
  modalView.classList.remove('modal-view--visible');
  modalView.inert = true;
  const page = document.querySelector('.page');
  page.classList.remove('page--blur');
  page.inert = false;
  document.querySelector('body').classList.remove('u-no-scroll');
  sender.focus();
  sender.setAttribute('aria-expanded', false);
  callback();
};

const showModal = (modal, sender, hideCallback = () => {}) => {
  const modalView = document.getElementById(modal);
  modalView.classList.add('modal-view--visible');
  modalView.inert = false;
  const page = document.querySelector('.page');
  page.classList.add('page--blur');
  page.inert = true;
  document.querySelector('body').classList.add('u-no-scroll');
  sender.setAttribute('aria-expanded', true);

  modalView.focus();

  const clickEvent = (event) => {
    if (event.target === modalView) {
      hideModal(modal, sender, hideCallback);
    }
  };

  const keyEvent = (event) => {
    if (event.keyCode === 27) {
      hideModal(modal, sender, hideCallback);
    }
  };

  modalView.removeEventListener('click', clickEvent);
  modalView.addEventListener('click', clickEvent);
  window.removeEventListener('keyup', keyEvent);
  window.addEventListener('keyup', keyEvent);
};

export {
  hideModal,
  showModal,
};
